<div class="worksheet" (window:beforeunload)="ngOnDestroy()" [ngClass]="{'new-window' : newWindow}" #worksheet>
  <div class="component-header">
    <div class="mat-title" [matMenuTriggerFor]="wks" matTooltipPosition="above" matTooltip="Gerenciar Planilhas">
      <mat-form-field *ngIf="worksheetSelected">
        <input readonly matInput *ngIf="isRequestServer" value="Aguarde...">
        <input readonly matInput *ngIf="!isRequestServer" [(value)]="worksheetSelected.Title">
        <mat-icon matSuffix class="icon-arrow" svgIcon="arrow-down"
          *ngIf="!isRequestServer && ((listShareDefaultWorksheets && listShareDefaultWorksheets?.length > 0) || (listShareWorksheets && listShareWorksheets?.length > 0))">
        </mat-icon>
      </mat-form-field>
    </div>
    <mat-menu class="custom-mat-menu worksheet mat-btn-wkst" #wks="matMenu" [overlapTrigger]="false">
      <div *ngIf="organization?.worksheet?.showWorksheetShareDefault && listShareDefaultWorksheets?.length > 0">
        <div class="mat-title-wks divisor">Pré Definidas</div>
        <mat-list *ngFor="let item of listShareDefaultWorksheets">
          <mat-list-item id="worksheet-name-{{item.Id}}" class="list-item-menu"
            [ngClass]="{'selected' : worksheetSelected?.Id == item?.Id}" (click)="changeWorksheetShare(item.Id, true)">
            <span>{{ item?.Title }}</span>
          </mat-list-item>
        </mat-list>
      </div>
      <div *ngIf="!isWksOffline">
        <div class="mat-title-wks divisor">Minhas Planilhas</div>
        <mat-list *ngFor="let item of listShareWorksheets">
          <mat-list-item id="worksheet-name-{{item.Id}}" class="list-item-menu"
            [ngClass]="{'selected' : worksheetSelected?.Id == item?.Id}" (click)="changeWorksheetShare(item.Id, false)"
            *ngIf="!editingWorksheetShare(item?.Id)">
            <span>{{ item?.Title }}</span>
            <div>
              <mat-icon id="edit-worksheet-name" (click)="doEditTitleWorksheetShare(item.Id)" svgIcon="edit"
                matTooltipPosition="above" matTooltip="Editar Planilha"></mat-icon>
              <mat-icon id="confirm-worksheet-name" class="delete" (click)="deleteWorksheetShare(item, $event, false)"
                svgIcon="delete-white" matTooltipPosition="above" matTooltip="Deletar Planilha"
                *ngIf="listShareWorksheets?.length > 1">
              </mat-icon>
            </div>
          </mat-list-item>
          <mat-list-item *ngIf="editingWorksheetShare(item.Id)"
            [ngClass]="{'selected' : worksheetSelected.Id == item.Id}">
            <input id="input-worksheet-name" (click)="$event.stopPropagation()" matInput maxlength="30" minlength="3"
              (keydown.enter)="renameWorksheetShare($event, item.Id);"
              (keydown.esc)="renameWorksheetShare($event,item.Id)" (focusout)="renameWorksheetShare($event,item.Id)"
              type="text" value="{{item.Title}}" autocomplete="off">
            <mat-icon matSuffix (click)="renameWorksheetShare($event,item.Id)" svgIcon="done">
            </mat-icon>
          </mat-list-item>
        </mat-list>
      </div>
      <button id="add-worksheet" class="mat-btn-wkst" (click)="newWorksheetShare()" [disabled]="isRequestServer"
        *ngIf="!isWksOffline">
        <mat-icon class="icon-mat-list" svgIcon="add"></mat-icon>
        <span class="create-message cursor">Adicionar planilha</span>
      </button>
    </mat-menu>
    <div class="icons gridster-ignore-drag">
      <div class="row m-0 row-btns">
        <button *ngIf="!newWindow && !isWksOffline" class="btn-add" (click)="addNew()" matTooltipPosition="above"
          matTooltip="{{ isRequestServer ? messageRequestServer : selectedWorksheetDefault ? messageAddWorksheet : 'Adicionar Ativo'}}"
          [disabled]="isRequestServer">
          <mat-icon svgIcon="more" class="add-icon"></mat-icon>
          <span>ATIVO</span>
        </button>
        <mat-icon svgIcon="search" (click)="openFilter()" matTooltipPosition="above" matTooltip="Pesquisar Ativo"
          *ngIf="!isWksOffline">
        </mat-icon>
        <app-auto-complete #inputFilter id="input-filter" class="input-filter" [autoFocus]="true"
          (keyup)="keyup($event)" (onsymbolChanged)="symbolChanged($event)" [ngClass]="{'open': filterOn}"
          *ngIf="!isWksOffline">
        </app-auto-complete>
        <mat-icon svgIcon="close" class="close-filter" (click)="closeFilter()" [ngClass]="{'open': filterOn}"
          *ngIf="!isWksOffline">
        </mat-icon>
        <mat-icon svgIcon="filter" class="open-config" (click)="openConfig($event)" matTooltipPosition="above"
          matTooltip="Configurar Colunas" *ngIf="!isWksOffline"></mat-icon>
        <mat-icon *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
        <mat-icon disableWksChange *ngIf="!newWindow" class="close-btn" svgIcon="close" (click)="removeGrid()"
          matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
        </mat-icon>
      </div>
    </div>
  </div>
  <div class="container-fluid  gridster-ignore-drag">
    <div class="loading" *ngIf="loading">
      <app-spinner-loading class="spinner"></app-spinner-loading>
    </div>
    <div class="action-div" [ngClass]="{'show': checkedItems || checkIndeterminate}">
      <div class="row row-action">
        <div class="col col-data-remove">
          <mat-checkbox class="chk-delete" [(ngModel)]="checkedItems" [(indeterminate)]="checkIndeterminate"
            labelPosition="after" (change)="changeCheck($event)">
            {{lengthChecked + (lengthChecked > 1 ? ' ATIVOS SELECIONADOS' : ' ATIVO SELECIONADO')}}
          </mat-checkbox>
        </div>
        <div *ngIf="loggedNegotiation && lengthChecked == 1 && validateSelectedForBillet()" class="col action-btn btn-buy"
          (click)="openBuyOrSellBilletFromSelected('buy')">
          <mat-icon class="pointer buy-icon-white" svgIcon="funds"></mat-icon>
          Comprar ativo
        </div>
        <div *ngIf="loggedNegotiation && lengthChecked == 1 && validateSelectedForBillet()" class="col action-btn btn-sell"
          (click)="openBuyOrSellBilletFromSelected('sell')">
          <mat-icon class="pointer sell-icon-white" svgIcon="cash"></mat-icon>
          Vender ativo
        </div>
        <div class="col-3 action-btn btn-rem" (click)="deleteWorksheetShare(null, null, true)">
          <mat-icon class="pointer delete-icon-white" svgIcon="delete-white"></mat-icon>
          {{(lengthChecked > 1 ? ' Excluir ativos' : ' Excluir ativo')}}
        </div>
      </div>
    </div>
    <div class="row row-content">
      <div class="col-12 p-0">
        <ag-grid-angular #agGrid [ngClass]="{'uncheck': !checkedItems && !checkIndeterminate}"
          class="ag-theme-balham color-autocomplete" style="width: 100%;height: 100%;" [gridOptions]="gridOptions"
          [enableSorting]="true" [rowData]="rowData" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
          [suppressRowClickSelection]="true" [enableCellChangeFlash]="false" [deltaRowDataMode]="true"
          [animateRows]="true" [defaultColDef]="defaultColDef" (cellClicked)='onCellClicked($event)'
          (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"
          (selectionChanged)="onSelectionChanged($event)" (cellEditingStarted)="editingStarted($event)"
          (cellEditingStopped)="editingStopped($event)" (cellContextMenu)="onCellContextMenu($event)">
        </ag-grid-angular>
      </div>
    </div>
  </div>
  <div (window:beforeunload)="closeSheet()"></div>
</div>
